import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@brokerbay/design-components';

export type AgreeToTermsCheckboxProps = {
  value: boolean;
  onChange: (val: boolean) => void;
};

const AgreeToTermsCheckbox = (props: AgreeToTermsCheckboxProps) => {
  const { value, onChange } = props;

  return (
    <MultilineCheckbox
      value={value}
      onChange={e => onChange(e.target.checked)}
      data-cy="checkbox-agree-to-terms"
    >
      I am an authorized representative of this brokerage and am able to enter
      into agreements on behalf of the brokerage.
    </MultilineCheckbox>
  );
};

export default AgreeToTermsCheckbox;

const MultilineCheckbox = styled(Checkbox)``;
